import { render, staticRenderFns } from "./DashboardActionsWidget.vue?vue&type=template&id=37958113&scoped=true"
import script from "./DashboardActionsWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardActionsWidget.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DashboardActionsWidget.vue?vue&type=style&index=0&id=37958113&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37958113",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37958113')) {
      api.createRecord('37958113', component.options)
    } else {
      api.reload('37958113', component.options)
    }
    module.hot.accept("./DashboardActionsWidget.vue?vue&type=template&id=37958113&scoped=true", function () {
      api.rerender('37958113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/DashboardWidgets/actions/DashboardActionsWidget.vue"
export default component.exports